import React, { useCallback, useEffect, useState } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import Card from "../../components/Forms/Card";
import { getAuthReq } from "../../utils/apiHandlers";
import MainTable from "./child/MainTable";
import Spinner from "../../components/loaders/Spinner";
import { useSelector } from "react-redux";
import useDateFilter from "../../hooks/useDateFilter";
import { debounce } from "lodash";
import { getQueryString } from "../../utils/function";

const Report = () => {
  const take = 5;
  const { userData } = useSelector((state) => state?.user || {});
  const [isLoading, setIsLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [dashboardData, setDashboardData] = useState({});
  const [commissionData, setCommissionData] = useState({});
  const { selectedFromDate, selectedToDate, dateRangeFilterUi } =
    useDateFilter();
  const [listData, setListData] = useState({
    count: 0,
    data: []
  });
  const navigate = useNavigate();

  const handlePage = (e, page) => {
    e.preventDefault();
    setPageNumber(page);
  };

  const headings = [
    "Sr. no",
    "Node ID",
    "Date",
    "Total Validated Block",
    "Hash Count",
    "View"
  ];
  const handleNavigate = (item, idx) => {
    navigate(`/report/${idx}`, {
      state: {
        ...item
      }
    });
  };

  const fetchDashboardReport = async (userData) => {
    setIsLoading(true);
    const res = await getAuthReq(
      `/reports/dashboard?userId=${userData?.id}&stageId=1`
    );
    const { status, data } = res;
    if (status) {
      setIsLoading(false);
      setDashboardData(data);
    }
  };

  const fetchAllReport = async (skip, take, nodeID) => {
    setIsLoading(true);
    let start = moment(selectedFromDate).format("YYYY-MM-DD");
    let end = moment(selectedToDate).format("YYYY-MM-DD");
    let nodeIdParam = "";
    if (nodeID) {
      nodeIdParam = `&nodeId=${nodeID}`;
    }
    const res = await getAuthReq(
      `/reports/all?skip=${skip}&take=${take}&startDate=${start}&endDate=${end}${
        nodeIdParam && nodeIdParam
      }`
    );
    const { status, data } = res;
    if (status) {
      setListData({ count: data.count, data: data.data });
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (userData && Object.keys(userData).length > 0) {
      fetchDashboardReport(userData);
    }
  }, [userData]);
  useEffect(() => {
    fetchAllReport((pageNumber - 1) * take, take);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumber, take, selectedFromDate, selectedToDate]);

  const fetchCommissionReports = async () => {
    setIsLoading(true);
    const query = getQueryString({
      startDate: moment(selectedFromDate).format("YYYY-MM-DD"),
      endDate: moment(selectedToDate).format("YYYY-MM-DD"),
      powerFranchiseId: userData?.id
    });
    const res = await getAuthReq(`/power-franchise/dashboard?${query}`);
    const { status, data } = res;
    if (status) {
      setCommissionData(data?.data);
    }
    setIsLoading(false);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedFetchUsers = useCallback(
    debounce(() => fetchCommissionReports(), 500), // 500ms debounce delay
    [selectedFromDate, selectedToDate, userData?.id]
  );

  useEffect(() => {
    if (userData?.id) {
      debouncedFetchUsers();
    }
    return () => {
      debouncedFetchUsers.cancel();
    };
  }, [debouncedFetchUsers, userData?.id]);

  return (
    <>
      {/* <ComingSoon /> */}
      {isLoading && <Spinner />}

      <div className="h-[100%]">
        <div className="flex items-center justify-between mb-3 md:mb-10">
          <h4 className="cursor-pointer text-white text-start md:text-center text-16 md:text-[24px] lg:text-[24px]">
            Report
          </h4>
        </div>

        <div>
          <Card data={dashboardData} userData={userData} type="one" />
        </div>
        <div className=" flex-col flex lg:flex-row lg:items-center gap-4  w-full xl:w-full mb-5 mt-10">
          <div className="flex items-center w-full justify-between mb-3 md:mb-10">
            <h4 className="cursor-pointer text-white text-start md:text-center text-16 md:text-[24px] lg:text-[24px]">
              Commission Report
            </h4>
            {dateRangeFilterUi()}
          </div>
        </div>
        <div>
          <div>
            <Card data={commissionData} userData={userData} type="two" />
          </div>
        </div>
        <div className="hidden">
          <MainTable
            headings={headings}
            handleNavigate={handleNavigate}
            pageNumber={pageNumber}
            listData={listData}
            handlePage={handlePage}
            take={take}
            setPageNumber={setPageNumber}
          />
        </div>
      </div>
    </>
  );
};
export default Report;
